import { useEffect, useState, useContext } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Box,
} from "@mui/material";
import AsyncSelect from "react-select/async";
import { Search as SearchIcon } from "@mui/icons-material";
import { LanguageContext } from "App";
import QuickDate from "../../../components/QuickDate";
import SearchAccSessionReq from "../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import SearchUserModel from "../../../Classes/Models/Requests/Users/SearchUser";
import UsersApi from "../../../Classes/API/UsersApi";
import NewQuickDate from "../../../components/QuickDate/NewQuickDate";
import ThreeStateCheckbox from "../../../components/ThreeStateCheckbox";

const SearchSingleSessions = ({ setSearchReq, GetTableData }) => {
  const { translations } = useContext(LanguageContext);
  const [AccountingEntryId, setAccountingEntryId] = useState();
  const [Id, setId] = useState();
  const [IsPaidFor, setIsPaidFor] = useState();
  const [IsException, setIsException] = useState();
  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState({});
  const [SessionName, setSessionName] = useState();
  const [patientPhoneNumber, setpatientPhoneNumber] = useState();
  const [TimeStampFrom, setTimeStampFrom] = useState();
  const [TimeStampTo, setTimeStampTo] = useState();
  const [AppointmentDateFrom, setAppointmentDateFrom] = useState();
  const [AppointmentDateTo, setAppointmentDateTo] = useState();
  const [TherapistSearch, setTherapistSearch] = useState("");
  const [Therapist, setTherapist] = useState(null);

  const [OptionPatient, setOptionPatient] = useState([]);
  const [OptionSelectTherapist, setOptionSelectTherapist] = useState([]);
  useEffect(() => {
    getTherapists().then((res) => {
      setOptionSelectTherapist(res);
    });
  }, [TherapistSearch]);

  const getPatients = async (inputValue = "") => {
    const searchReq = new SearchUserModel();
    searchReq.userType = "Patient";
    searchReq.name = inputValue;
    const res = await UsersApi.SearchUsers(searchReq);

    console.log(res.data.list);

    const result =
      res.status === "Success"
        ? res.data.list.map((item) => ({
            value: { ...item.getPatient, name: item.name },
            label: item.name,
          }))
        : [];

    // if (searchParams.patientId) {
    //   result.push({ value: null, label: "No Patient" });
    // }

    return result;
  };

  useEffect(() => {
    getPatients().then((res) => {
      setOptionPatient(res);
    });
  }, [PatientsSearch]);

  const [searchParams, setSearchParams] = useState({
    ...new SearchAccSessionReq(),
    patient: undefined,
    therapist: undefined,
  });

  const handleInputChange = (field, value) => {
    console.log({ field, value });

    const therapistId = field === "therapist" ? value?.id : searchParams.therapistId;
    const patientId = field === "patient" ? value?.id : searchParams.patientId;

    setSearchParams((prev) => ({ ...prev, [field]: value, therapistId, patientId }));
  };

  const getTherapists = async (inputValue = "") => {
    console.log({ inputValue });
    const searchReq = new SearchUserModel();
    searchReq.userType = "Therapist";
    searchReq.name = inputValue;
    const res = await UsersApi.SearchUsers(searchReq);

    const result =
      res.status === "Success"
        ? res.data.list.map((item) => ({
            value: { ...item.getTherapist, name: item.name },
            label: item.name,
          }))
        : [];

    // if (searchParams.therapistId) {
    //   result.push({ value: null, label: "No Therapist" });
    // }

    return result;
  };

  const onSearch = async () => {
    const formattedParams = {
      ...searchParams,
      appointmentDateFrom: searchParams.appointmentDateFrom
        ? searchParams.appointmentDateFrom + "T00:00:00"
        : undefined,
      appointmentDateTo: searchParams.appointmentDateTo
        ? searchParams.appointmentDateTo + "T23:59:59"
        : undefined,
      timeStampFrom: searchParams.timeStampFrom
        ? searchParams.timeStampFrom + "T00:00:00"
        : undefined,
      timeStampTo: searchParams.timeStampTo ? searchParams.timeStampTo + "T23:59:59" : undefined,
    };

    setSearchReq(formattedParams);
    await GetTableData();
  };

  useEffect(() => {
    searchParams.appointmentDateTo;

    setSearchReq({
      ...searchParams,
      appointmentDateFrom: searchParams.appointmentDateFrom
        ? searchParams.appointmentDateFrom + "T00:00:00"
        : undefined,
      appointmentDateTo: searchParams.appointmentDateTo
        ? searchParams.appointmentDateTo + "T23:59:59"
        : undefined,
      timeStampFrom: searchParams.timeStampFrom
        ? searchParams.timeStampFrom + "T00:00:00"
        : undefined,
      timeStampTo: searchParams.timeStampTo ? searchParams.timeStampTo + "T23:59:59" : undefined,
    });
  }, [searchParams, setSearchReq]);

  // const ThreeStateCheckbox = ({ label, value, onChange }) => {
  //   const getLabel = () => {
  //     if (value === null || value === undefined) return `${label}: Any`;
  //     return `${label}: ${value ? "Yes" : "No"}`;
  //   };

  //   const handleClick = () => {
  //     if (value === null || value === undefined) onChange(true);
  //     else if (value === true) onChange(false);
  //     else onChange(null);
  //   };

  //   return (
  //     <Button
  //       onClick={handleClick}
  //       style={{ display: "flex", alignItems: "center", color: "black", padding: 0 }}
  //     >
  //       <Checkbox
  //         checked={value || value === false}
  //         indeterminate={value === null || value === undefined}
  //       />
  //       {getLabel()}
  //     </Button>
  //   );
  // };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" fontWeight="medium" gutterBottom>
          {translations.createAccountsessionSingleSessionSearchSearch}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label={translations.createAccountsessionSingleSessionSearchAccountingSessionId}
              value={searchParams.sessionId || ""}
              onChange={(e) => handleInputChange("sessionId", e.target.value || undefined)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <AsyncSelect
              isClearable
              cacheOptions
              defaultOptions={OptionPatient}
              loadOptions={getPatients}
              value={
                searchParams.patient
                  ? { value: searchParams.patient, label: searchParams.patient.name }
                  : null
              }
              onChange={(selected) => handleInputChange("patient", selected?.value)}
              placeholder={translations.createAccountsessionSingleSessionSearchSelectPatient}
              styles={{
                control: (provided) => ({
                  ...provided,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label={translations.createAccountsessionSingleSessionSearchSessionName}
              value={searchParams.sessionName || ""}
              onChange={(e) => handleInputChange("sessionName", e.target.value || undefined)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              label={translations.createAccountsessionSingleSessionSearchPatientMobileNumber}
              value={searchParams.phoneNumber || ""}
              onChange={(e) => handleInputChange("phoneNumber", e.target.value || undefined)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <AsyncSelect
              isClearable
              cacheOptions
              defaultOptions={OptionSelectTherapist}
              loadOptions={getTherapists}
              value={
                searchParams.therapist
                  ? { value: searchParams.therapist, label: searchParams.therapist.name }
                  : null
              }
              onChange={(selected) => handleInputChange("therapist", selected?.value)}
              placeholder={
                translations.createAccountsessionSingleSessionSearchSelectbytherapistname
              }
              styles={{
                control: (provided) => ({
                  ...provided,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexWrap="wrap" gap={3}>
              <div style={{ flex: 1 }}>
                <ThreeStateCheckbox
                  label={translations.createAccountsessionSingleSessionSearchIsPaidFor}
                  value={searchParams.isPaidFor}
                  onChange={(value) => handleInputChange("isPaidFor", value)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <ThreeStateCheckbox
                  label={translations.createAccountsessionSingleSessionSearchExceptions}
                  value={searchParams.isException}
                  onChange={(value) => handleInputChange("isException", value)}
                />
              </div>
              {/* <div style={{ flex: 1 }}>
                <ThreeStateCheckbox
                  label={translations.createAccountsessionSingleSessionSearchPostPaid}
                  value={searchParams.isPostPaid}
                  onChange={(value) => handleInputChange("isPostPaid", value)}
                />
              </div> */}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              {translations.createAccountsessionSingleSessionSearchTimeStampDateRange}
            </Typography>
            <NewQuickDate
              setFrom={(date) => handleInputChange("timeStampFrom", date)}
              setTo={(date) => handleInputChange("timeStampTo", date)}
              from={searchParams.timeStampFrom}
              to={searchParams.timeStampTo}
              placeholder="Quick Last Updated"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              {translations.createAccountsessionSingleSessionSearchAppointmentDateRange}
            </Typography>
            <NewQuickDate
              setFrom={(date) => handleInputChange("appointmentDateFrom", date)}
              setTo={(date) => handleInputChange("appointmentDateTo", date)}
              from={searchParams.appointmentDateFrom}
              to={searchParams.appointmentDateTo}
              placeholder="Quick Appointment Date"
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
          <Button
            style={{ color: "white", backgroundColor: "#3560AD" }}
            variant="contained"
            color="primary"
            onClick={() => {
              setSearchParams(new SearchAccSessionReq());
            }}
          >
            {translations.createAccountsessionSingleSessionSearchSearchpatientsClear}
          </Button>
          <Button
            style={{ color: "white", backgroundColor: "#3560AD" }}
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={onSearch}
          >
            {translations.createAccountsessionSingleSessionSearchSearchpatients}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SearchSingleSessions;
